import { Button } from "../ui/button";
import { useModal } from "@/hooks/useModal";
import { auth } from "@/helpers/firebase";
import { signOut } from "@/bridge/signOut";
import { PersistentData } from "@/helpers/PersistentData";
import { useViewTransition } from "@/hooks/useViewTransition";

export function LogoutModal() {
    const { closeModal } = useModal();
    const { navigateNormal } = useViewTransition(); 

    const handleLogout = async () => {
        await Promise.all([
            auth.signOut(),
            signOut(),
            localStorage.clear(),
            PersistentData.clear(),
          ]);

        closeModal();

        navigateNormal("/home", {
            replace: true,
            viewTransition: true,
        });
    }

    return (
        <div className="bg-white rounded-xl shadow-lg py-8 px-2 w-64 h-80 text-center flex flex-col justify-between">
            <div>
                <div className="h-16 mx-auto mb-4 text-6xl">
                    🚨
                </div>

                <h2 className="text-blue-dark text-2xl font-semibold mb-4 mx-4.5">Log out</h2>
                <p className="text-blue-dark mb-8 mx-5 text-xl">Are you sure?</p>
            </div>
            
            <div className="flex gap-2 justify-center mb-6">
                <Button variant='wallet-btn' size='walletBtn' className="bg-red-500 text-white w-24"
                    onClick={() => handleLogout()}>
                    Logout
                </Button>
                <Button shine variant='wallet-btn' size='walletBtn' className="bg-blue text-white w-24"
                onClick={() => closeModal()}>
                    Stay
                </Button>
            </div>
        </div>
    );
};